import Link from "next/link";

interface CtaButton {
  to: string;
  label: string;
}

interface CtaBlockProps {
  title: string;
  text: string;
  primary: CtaButton;
  secondary?: CtaButton;
}

export function CtaBlock({ title, text, primary, secondary }: CtaBlockProps) {
  return (
    <section className="py-16 sm:py-20 md:py-24 bg-foreground text-card border-b border-[#22262C]"
     style={{
  backgroundImage: `
    linear-gradient(hsla(0, 0%, 100%, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, hsla(0, 0%, 100%, 0.06) 1px, transparent 1px)
  `,
  backgroundSize: "44px 44px",
}}>
  
      <div className="container mx-auto px-4 text-center">
        {/* Dynamic Title */}
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight break-words">
          {title}
        </h2>
        
        {/* Dynamic Text Description */}
        <p className="text-muted-foreground mt-4 max-w-xl mx-auto text-base sm:text-lg leading-relaxed">
          {text}
        </p>

        {/* Action Buttons Container */}
        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
          {/* Primary Action Button with Glow & Lift Effect */}
          <Link
            href={primary.to}
            className="inline-block w-full sm:w-auto bg-[oklch(0.62_0.21_255)] text-[oklch(1_0_0)] px-8 sm:px-10 py-4 rounded-[calc(var(--radius)+4px)] font-bold text-base transition-[transform,box-shadow,border-color] duration-250 ease-out hover:-translate-y-[3px] hover:shadow-[0_18px_40px_-22px_color-mix(in_oklab,oklch(0.62_0.21_255)_50%,transparent)] border border-[oklch(0.62_0.21_255)]"
          >
            {primary.label}
          </Link>

          {/* Conditional Secondary Action Button with Light Subtle Effect */}
          {secondary && (
            <Link
              href={secondary.to}
              className="group text-secondary px-8 py-4 rounded-lg font-bold text-base transition-all duration-300 hover:-translate-y-1 ring-1 border border-secondary w-full sm:w-fit text-center hover:glow-secondary"
            >
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
